export const rootCss = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
